export const BRAND_NAME = 'Adanionline247';
// Note: It is the main site url. Ex - mazaa.io, etc.
export const BRAND_DOMAIN = 'adanionline247.com';
// Note: It is the main site url. Ex - mazaa.io, etc.
export const BRAND_DOMAIN_SKIN_URL = 'adanionline247.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'mnto9.com';
